// IMP-045: 전역 에러 처리 Layer 3 — React ErrorBoundary
// 앱 최상위에서 렌더링 중 throw 된 예외를 포착하여 fallback UI 표시 및 Sentry 보고
// route 전환 시 hasError 자동 리셋 — 단일 최상위 boundary 의 폭발반경 시간적 격리
import React from 'react';
import * as Sentry from '@sentry/react';
import i18next from 'i18next';
import { history } from '../../history';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidMount() {
        this.unlisten = history.listen(() => {
            if (this.state.hasError) this.setState({ hasError: false });
        });
    }

    componentWillUnmount() {
        if (this.unlisten) { this.unlisten(); }
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, { extra: errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    <div className="text-center p-4">
                        <h2 className="mb-3">{i18next.t('errorBoundaryTitle')}</h2>
                        <p className="text-muted mb-4">{i18next.t('errorBoundaryMessage')}</p>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => window.location.reload()}
                        >
                            {i18next.t('errorBoundaryRefresh')}
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
